module.exports = __webpack_public_path__ + "static/media/template-admin.a9ec8e4f.xlsx";